import React, { useState } from 'react';
import { Lang } from '../types';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { GalleryCarousel } from '../components/GalleryCarousel';
import { PassionGallery } from '../components/PassionGallery';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { BookingForm } from '../components/BookingForm';
import { FAQSection } from '../components/FAQSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { BookingToast } from '../components/BookingToast';
export function LandingPage() {
  const [lang, setLang] = useState<Lang>('en');
  return <div className="min-h-screen bg-studio-bg text-studio-text font-inter selection:bg-studio-accent selection:text-studio-bg" data-id="element-303">
      {/* Ambient light sweep animation */}
      <div className="light-sweep" aria-hidden="true" data-id="element-304" />

      <Navbar lang={lang} setLang={setLang} data-id="element-305" />

      <main data-id="element-306">
        <HeroSection lang={lang} data-id="element-307" />
        <GalleryCarousel lang={lang} data-id="element-308" />
        <PassionGallery lang={lang} data-id="element-309" />
        <ForWhoSection lang={lang} data-id="element-310" />
        <BenefitsSection lang={lang} data-id="element-311" />
        <HowItWorksSection lang={lang} data-id="element-312" />
        <BookingForm lang={lang} data-id="element-313" />
        <FAQSection lang={lang} data-id="element-314" />
        <TestimonialsSection lang={lang} data-id="element-315" />
        <FinalCTA lang={lang} data-id="element-316" />
      </main>

      <Footer lang={lang} data-id="element-317" />

      <BookingToast lang={lang} data-id="element-318" />
    </div>;
}